import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpStatusCode} from "@angular/common/http";
import {LoaderService} from "../../../../services/loader/loader.service";
import {ActivatedRoute} from "@angular/router";
import {RestResponse} from "../../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../../Helper/RestHelper";
import {Filterresponse} from "../../../../Interfaces/filterresponse.interface";
import {Customer} from "../../../../Interfaces/customer.interface";

@Component({
  selector: 'app-customerform',
  templateUrl: './customerform.component.html',
  styleUrl: './customerform.component.css'
})
export class CustomerformComponent {

  public customerform: FormGroup = this.formBuilder.group({
    display_name: ["", [Validators.required, Validators.minLength(4)]],
    company_name: ["", [Validators.required]],
    zipcode: [""],
    city: [""],
    district: [""],
    street: [""],
    archived: [""]
  })
  public sentstatus: number = 0

  public industry_filter: any;
  public contracttype_filter: any;
  public timemodel_filter: any;
  public remote_filter: any;

  public operation: string | undefined
  public uuid: string | undefined
  public customer: Customer | undefined

  public apierror: boolean = true

  constructor(private httpClient: HttpClient, private formBuilder: FormBuilder, protected loader: LoaderService, private route: ActivatedRoute) {
    this.loader.showLoader()
    this.route.params.subscribe(params => {
      this.operation = params['operation']
      this.uuid = params['uuid']
    });

    if (this.operation === "edit" || this.operation === "delete") {
      if (this.uuid === undefined) {
        //TODO Error UUID ist benötigt wenn create, update oder delete
        return
      }

      this.httpClient.get<RestResponse<Customer[]>>(RestHelper.API_BASE_URL + "customer/getCustomer?uuid=" + this.uuid, RestHelper.requestOptions).subscribe({
        next: (value) => {
          console.log(value.data)

          this.customer = value.data[0]

          console.log(this.customer)

          this.getFormControls()['display_name'].setValue(this.customer.display_name)
          this.getFormControls()['company_name'].setValue(this.customer.company_name)
          this.getFormControls()['zipcode'].setValue(this.customer.zipcode)
          this.getFormControls()['city'].setValue(this.customer.city)
          this.getFormControls()['district'].setValue(this.customer.district)
          this.getFormControls()['street'].setValue(this.customer.street)
          this.getFormControls()['archived'].setValue(this.customer.archived)

          if (this.operation === "delete") {
            this.customerform.disable()
          }

          this.loader.hideLoader()
          this.apierror = false
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    }

    this.httpClient.get<RestResponse<Filterresponse[]>>(RestHelper.API_BASE_URL + "searchfilter/getSearchFilter", RestHelper.requestOptions).subscribe({
      next: (value) => {

        this.industry_filter = value.data.filter(value1 => value1.filterName === "industry")?.at(0)?.filter
        this.contracttype_filter = value.data.filter(value1 => value1.filterName === "contract_type")?.at(0)?.filter
        this.timemodel_filter = value.data.filter(value1 => value1.filterName === "timemodel")?.at(0)?.filter
        this.remote_filter = value.data.filter(value1 => value1.filterName === "remote")?.at(0)?.filter

        this.loader.hideLoader()
        this.apierror = false
      }, error: () => {
        this.apierror = true
        this.loader.hideLoader()
      }
    })
  }

  public getOperation(): string {
    switch (this.operation) {
      case "create":
        return "Erstellen"
      case "edit":
        return "Bearbeiten"
      case "delete":
        return "Löschen"
    }
    return ""
  }

  public onSubmit() {
    if (!this.customerform.valid) {
      this.customerform.markAllAsTouched()
      for (let el in this.customerform.controls) {
        if (this.customerform.controls[el].errors) {
          console.log(el)
        }
      }
      console.log("Form Invalid")
      return;
    }

    const body = new FormData();
    body.append("display_name", this.customerform.value.display_name)
    body.append("company_name", this.customerform.value.company_name)
    body.append("zipcode", this.customerform.value.zipcode)
    body.append("city", this.customerform.value.city)
    body.append("district", this.customerform.value.district)
    body.append("street", this.customerform.value.street)
    body.append("archived", this.customerform.value.archived)
    if (this.operation === "edit") {
      body.append("uuid", String(this.uuid))
    }
    if (this.operation === "create") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'customer/createCustomer', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
            this.customerform.reset()
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    } else if (this.operation === "edit") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'customer/updateCustomer', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    }
  }

  public getFormControls() {
    return this.customerform.controls;
  }

  protected readonly Validators = Validators;
}
